export default "__VITE_ASSET__BvgTauum__"